<div class="count">
  <div class="title" *ngIf="hasReferenceStats() && !onlyData">
    <h4>
      {{ getTitle() | translate }}
      <span *ngIf="isDensityActive()"
        >&nbsp;({{ keyIndicator | translate }}/km²,
        {{ 'median' | translate }})</span
      >
      <span class="datasetDate">
        <img src="/assets/img/icons/positive-clear/dataset-xs.svg" />
        {{ datasetName | translate }}
      </span>
      <span class="datasetDate" *ngIf="selectedCompareDelivery">
        <img src="/assets/img/icons/positive-clear/dataset-xs.svg" />
        {{ selectedCompareDelivery.name | translate }}
      </span>
    </h4>
  </div>
  <div class="content">
    <p class="value" [class.visitors]="!hasReferenceStats()">
      <span>
        <span class="reference">
          <ng-container *ngIf="hasReferenceStats()">{{
            referenceStats | hideZeroValues : '1.0-0'
          }}</ng-container>
          <ng-container *ngIf="!hasReferenceStats()"
            >{{ getTitle() | translate }}
            <span *ngIf="isDensityActive()"
              >&nbsp;({{ keyIndicator | translate }}/km²,
              {{ 'median' | translate }})</span
            ></ng-container
          >
        </span>
        <ng-container *ngIf="compareMode">
          <span
            class="difference"
            [class.up]="percentDiff > 0"
            [class.down]="percentDiff < 0"
          >
            <ng-container *ngIf="percentDiff > 0">+</ng-container
            >{{ percentDiff | number : '1.1-2' }} <small>%</small>
          </span>
          <span class="compare">{{
            comparisonStats | hideZeroValues : '1.0-0'
          }}</span>
        </ng-container>
      </span>
      <span *ngIf="!hasReferenceStats()" class="datasetDate">
        <img src="/assets/img/icons/positive-clear/dataset-xs.svg" />
        {{ datasetName | translate }}
      </span>
    </p>
    <!-- <app-filter-summary *ngIf="referenceStats && showContext">
    </app-filter-summary> -->
  </div>
</div>
